
const userRegister = {
  // --- step one
  steps: {
    stepOne: true, // user validation
    stepTwo: false, // condiciones
    stepThree: false, // validar datos personales
    stepFour: false, // create user pass AD = skip
    stepSuccess: false,
  },
  UserInfo: {
    UserType: null,
    FirstName: null,
    MiddleName: null,
    LastName: null,
    MothersName: null,
    Email: null,
    Rut: null,
    Phone: null,
    serieCI: null,
    Birthdate: null,
    TempBD: false,
    Password: false,
    rePassword: false,
    RelationType: null,
    Rol: null,
    IsExACHS: false,
    acceptCondition: false,

  },
  emailValid: false,
  mailActivationAdParams: null,
  rutValid: false,
  QuestionsList: null,
  messageCreateUser: null,
  messageQuestions: null,
  validCINumber: true,
  skipValidation: false,
  fileUrl: null,

};

export default userRegister;

